import { render, staticRenderFns } from "./ReadDetail.vue?vue&type=template&id=26bfa5ec&scoped=true&"
import script from "./ReadDetail.vue?vue&type=script&lang=js&"
export * from "./ReadDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReadDetail.vue?vue&type=style&index=0&id=26bfa5ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bfa5ec",
  null
  
)

export default component.exports